import index from './zh-CN/index';
import testimonials from './zh-CN/testimonials';
import pricing from './zh-CN/pricing';
import contact from './zh-CN/contact';
import about from './zh-CN/about';
import features from './zh-CN/features';
import team from './zh-CN/team';

export default {
  ...index,
  ...testimonials,
  ...pricing,
  ...contact,
  ...about,
  ...features,
  ...team,

  'Button.index.749881-0': '立即下载',
  'Button.index.749881-1': '了解更多',
  'Button.index.749881-2': '开始使用',
  'Button.index.749881-3': '立即获取',

  'Menu.index.749881-0': '关于',
  'Menu.index.749881-1': '客户评价',
  'Menu.index.749881-2': '特性',
  'Menu.index.749881-3': '团队',
  'Menu.index.749881-4': '定价',
  'Menu.index.749881-5': '联系',
  'Contact.index.228792-0': '联系我们',
};
